import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const COMPLAINT_MANAGEMENT_ENDPOINT = '/api/v1/complaints';

const rejectRequest = (error, thunkApi) => {
  const data = error?.response?.data;
  const details = Array.isArray(data?.errors)
    ? data.errors.map((item) => item?.message).filter(Boolean)
    : [];

  return thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message:
      (details.length ? details.join(' ') : null) ??
      data?.message ??
      data?.error ??
      error?.message ??
      'Something went wrong',
  });
};

export const fetchQueries = createAsyncThunk(
  'complaintManagement/fetchQueries',
  async (params, thunkApi) => {
    try {
      const { complaintTypeId, page = 1, limit = 10, status, sort = '-createdAt' } = params || {};
      const queryParams = {
        page,
        limit,
        complaintTypeId,
        sort,
      };
      if (status != null && status !== '' && status !== 'all') {
        queryParams.status = status;
      }
      const response = await api.get(COMPLAINT_MANAGEMENT_ENDPOINT, {
        params: queryParams,
        signal: thunkApi.signal,
      });
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);
